/* eslint-disable no-plusplus */
/* eslint-disable class-methods-use-this */

import { STOCheckBasket } from 'commons/types';

import { SwipeRxWmsApi } from '../resources';
import { SwipeRxAPIResources } from '../resources/types';

import {
  ICheckBasketInfoPayloadDTO,
  ICheckBasketInfoResponseDTO,
  IGetSTOCheckBasketResponseDTO,
  ISTOEditBasketBoxNumberPalletPayloadDTO,
  ISTOEditBasketCheckedQtyPayloadDTO,
  ISTOEditBasketPickedQtyPayloadDTO,
} from './interfaces';

const dummySTOCheckBasket: STOCheckBasket = {
  warehouse_id: 1994,
  sto_number: 'STO1234567',
  checker: '1',
  createdAt: new Date(),
  updatedAt: new Date(),
  basket: 5,
  photo_url: [],
  items: [],
  is_scanned: false,
  picker: 'picker',
  total_sku: 0,
};

class SwipeRxWmsApiStoCheckBasket extends SwipeRxWmsApi {
  private readonly basePath: string;

  constructor() {
    super(SwipeRxAPIResources.STO_CHECK);
    this.basePath = `/${this.apiResource}`;
  }

  async getSTOCheckBasket(
    basket: number,
  ): Promise<IGetSTOCheckBasketResponseDTO> {
    try {
      const result = await this.get(
        `${this.basePath}/get-sto-check-basket/${basket}`,
      );

      if (!result.data) throw new Error('[FEError] Data not found');

      return result;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async getOnProgressSTOCheckBasket(
    stoNumber: string,
    basket: number,
  ): Promise<IGetSTOCheckBasketResponseDTO> {
    try {
      const result = await this.get(
        `${this.basePath}/get-on-progress-sto-check-basket`,
        {
          sto_number: stoNumber,
          basket,
        },
      );
      return result;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async checkBasketInfo(
    payload: ICheckBasketInfoPayloadDTO,
  ): Promise<ICheckBasketInfoResponseDTO> {
    try {
      const result = await this.patch(
        `${this.basePath}/check-basket-info`,
        payload,
      );
      return result;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async updatePickedQty(
    payload: ISTOEditBasketPickedQtyPayloadDTO,
  ): Promise<IGetSTOCheckBasketResponseDTO> {
    try {
      const result = await this.patch(
        `${this.basePath}/edit-picked-qty`,
        payload,
      );
      if (!result.data) throw new Error('[FEError] Update Qty Picked Failed');
      return result;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async updateCheckedQty(
    payload: ISTOEditBasketCheckedQtyPayloadDTO,
  ): Promise<IGetSTOCheckBasketResponseDTO> {
    try {
      const result = await this.patch(
        `${this.basePath}/edit-checked-qty`,
        payload,
      );
      if (!result.data) throw new Error('[FEError] Update Qty Checked Failed');
      return result;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async updateBoxNumberAndPallet(
    payload: ISTOEditBasketBoxNumberPalletPayloadDTO,
  ): Promise<IGetSTOCheckBasketResponseDTO> {
    try {
      const result = await this.patch(
        `${this.basePath}/edit-box-number-pallet`,
        payload,
      );
      if (!result.data) throw new Error('[FEError] Update Qty Failed');
      return result;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async completeChecking(stoNumber: string) {
    try {
      await this.post(`${this.basePath}/complete-checking`, {
        sto_number: stoNumber,
      });
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }
}

export const swipeRxWmsApiStoCheckBasket = new SwipeRxWmsApiStoCheckBasket();
